/**
 @description: API接口统一管理
 @date: 2021-08-22
 @author: pro(puluotech@gmail.com)
 */

import { IS_BETA, IS_REL } from './AppEnv';

let domain = '';

// 注意 ⚠️ ： 上面的domain地址改了的话，记得到 config/webpackDevServer.config.js:84 改对应环境的 proxy地址
if (process.env.NODE_ENV !== 'production') {
  if (IS_BETA) {
    domain = '/beta';
    //domain = '/release'
  } else if (IS_REL) {
    domain = '/release';
  } else {
    domain = '/production';
  }
}

export const API_BASE_URL = domain + '/api';

export const API_UPDATE_LOAD_IMAGE = `${API_BASE_URL}/admin/file/updateLoadImage`;

export const API_MEMBER_QUERY = `${API_BASE_URL}/admin/member/query`; // 用户列表
export const API_MEMBER_INTEGRAL = `${API_BASE_URL}/admin/member/integralDetail`; // 用户积分明细

export const API_ORDER_QUERY = `${API_BASE_URL}/admin/order/query`; // 零售订单
export const API_RETAIL_ORDER_QUERY = `${API_BASE_URL}/admin/retailOrder/query`; // 订货订单
export const API_ORDER_SHIPMENT = `${API_BASE_URL}/admin/order/sendProduct`; // 订单发货

export const API_INTEGRAL_ORDER_QUERY = `${API_BASE_URL}/admin/integralOrder/query`; // 积分订单
export const API_INTEGRAL_ORDER_SHIPMENT = `${API_BASE_URL}/admin/integralOrder/sendProduct`; // 积分订单发货
export const API_INTEGRAL_ORDER_BACK = `${API_BASE_URL}/admin/integralOrder/back`; // 寄售回收

export const API_TASK_QUERY = `${API_BASE_URL}/admin/task/query`; // 任务列表
export const API_TASK_ADD = `${API_BASE_URL}/admin/task/add`; // 添加任务
export const API_TASK_EDIT = `${API_BASE_URL}/admin/task/edit`; // 编辑任务
export const API_TASK_DEL = `${API_BASE_URL}/admin/task/delete`; // 删除任务
export const API_TASK_COUNT_LIST = `${API_BASE_URL}/admin/task/taskCountList`; // 任务级别数量列表
export const API_TASK_COUNT_UPDATE = `${API_BASE_URL}/admin/task/updateTaskCount`; // 配置任务级别数量

export const API_TASK_MEMBER_QUERY = `${API_BASE_URL}/admin/taskMember/query`; // 配置任务级别数量
export const API_TASK_MEMBER_PASS = `${API_BASE_URL}/admin/taskMember/pass`; // 配置任务级别数量
export const API_TASK_MEMBER_REFUSE = `${API_BASE_URL}/admin/taskMember/refuse`; // 配置任务级别数量

export const API_PRODUCT_QUERY = `${API_BASE_URL}/admin/product/query`; // 商品列表
export const API_PRODUCT_DETAIL = `${API_BASE_URL}/admin/product/detail`; // 商品详情
export const API_PRODUCT_ADD = `${API_BASE_URL}/admin/product/add`; // 新增商品
export const API_PRODUCT_EDIT = `${API_BASE_URL}/admin/product/edit`; // 新增商品
export const API_PRODUCT_DELETE = `${API_BASE_URL}/admin/product/delete`; // 删除商品

export const API_WALLET_DRAW_QUERY = `${API_BASE_URL}/admin/wallet/queryDraw`; // 提现列表
export const API_WALLET_PASS = `${API_BASE_URL}/admin/wallet/pass`; // 提现通过
export const API_WALLET_REFUSE = `${API_BASE_URL}/admin/wallet/refuse`; // 提现拒绝

export const API_ROLE_QUERY = `${API_BASE_URL}/role/query`; // 角色列表
export const API_ROLE_ADD = `${API_BASE_URL}/role/add`; // 创建角色
export const API_ROLE_UPDATE = `${API_BASE_URL}/role/update`; // 更新角色
/** */
export const API_USER_LOGIN = `${API_BASE_URL}/admin/system/login`; // 登录
export const LOGOUT_URL = `${API_BASE_URL}/admin/system/logout`; //退出
export const SYSTEM_INDEX = `${API_BASE_URL}/admin/system/index`; //首页

export const AUTHORITIES_LIST = `${API_BASE_URL}/admin/menu/authoritiesList`; // 查询菜单

export const GAME_CATEGORY_QUERY = `${API_BASE_URL}/gameCategory/query`; //查询游戏分类
export const GAME_CATEGORY_GET_BY_ID = `${API_BASE_URL}/gameCategory/getById`; //id查询游戏分类
export const GAME_CATEGORY_ADD = `${API_BASE_URL}/gameCategory/add`; //添加游戏分类
export const GAME_CATEGORY_DELETE = `${API_BASE_URL}/gameCategory/delete`; //删除游戏分类
export const GAME_CATEGORY_UPDATE = `${API_BASE_URL}/gameCategory/update`; //修改游戏分类

export const GET_GAME_LIST = `${API_BASE_URL}/gameList/getGameList`; //查询游戏列表
export const GAME_LIST_ADD = `${API_BASE_URL}/gameList/add`; //添加游戏
export const GAME_LIST_UPDATE = `${API_BASE_URL}/gameList/update`; //修改游戏
export const GAME_LIST_DELETE = `${API_BASE_URL}/gameList/delete`; //删除游戏
export const GAME_LIST_GET_BY_ID = `${API_BASE_URL}/gameList/getById`; //ID查询游戏

export const GET_GAME_MATERIAL_LIST = `${API_BASE_URL}/gameMaterial/getGameMaterialList`; //游戏素材列表
export const GAME_MATERIAL_ADD = `${API_BASE_URL}/gameMaterial/add`; //添加游戏素材
export const GAME_MATERIAL_UPDATE = `${API_BASE_URL}/gameMaterial/update`; //修改游戏素材
export const GAME_MATERIAL_DELETE = `${API_BASE_URL}/gameMaterial/delete`; //删除游戏素材
export const GAME_MATERIAL_GET_BY_ID = `${API_BASE_URL}/gameMaterial/getById`; //ID查询游戏素材

export const TECH_PARAM_QUERY = `${API_BASE_URL}/techParam/query` //游戏星星参数列表
export const TECH_PARAM_ADD = `${API_BASE_URL}/techParam/add` //添加游戏星星参数
export const TECH_PARAM_UPDATE = `${API_BASE_URL}/techParam/update` //修改游戏星星参数
export const TECH_PARAM_DELETE = `${API_BASE_URL}/techParam/delete` //删除游戏星星参数
export const TECH_PARAM_GET_BY_ID = `${API_BASE_URL}/techParam/getById` //ID查询游戏星星参数

export const GAME_LEVEL_QUERY = `${API_BASE_URL}/gameLevel/query` //游戏关卡列表
export const GAME_LEVEL_ADD = `${API_BASE_URL}/gameLevel/add` //添加游戏关卡
export const GAME_LEVEL_UPDATE = `${API_BASE_URL}/gameLevel/update` //修改游戏关卡
export const GAME_LEVEL_DELETE = `${API_BASE_URL}/gameLevel/delete` //删除游戏关卡
export const GAME_LEVEL_GET_BY_ID = `${API_BASE_URL}/gameLevel/getById` //ID查询游戏关卡

export const GAME_ACTION_ADD = `${API_BASE_URL}/gameAction/add` //添加游戏关卡规则
export const GAME_ACTION_UPDATE = `${API_BASE_URL}/gameAction/update` //修改游戏关卡规则
export const GAME_ACTION_DELETE = `${API_BASE_URL}/gameAction/delete` //删除游戏关卡规则
export const GAME_ACTION_GET_BY_ID = `${API_BASE_URL}/gameAction/getById` //ID查询游戏关卡规则

export const GAME_ADVISE_QUERY = `${API_BASE_URL}/gameAdvise/query` //查询游戏反馈记录

export const ADD_AUTHORITIES = `${API_BASE_URL}/admin/menu/addAuthorities`; // 新建菜单
export const EDIT_AUTHORITIES = `${API_BASE_URL}/admin/menu/editAuthorities`; // 修改菜单
export const DELETE_AUTHORITIES = `${API_BASE_URL}/admin/menu/deleteAuthorities`; // 删除菜单

export const USER_LIST = `${API_BASE_URL}/admin/user/userList`; // 用户列表
export const ADD_USER = `${API_BASE_URL}/admin/user/addUser`; // 添加用户
export const EDIT_USER = `${API_BASE_URL}/admin/user/editUser`; // 修改用户
export const DELETE_USER = `${API_BASE_URL}/admin/user/deleteUser`; // 删除用户
export const UPDATE_USER_STATUS = `${API_BASE_URL}/admin/user/updateUserStatus`; // 修改用户状态

export const ROLE_LIST = `${API_BASE_URL}/admin/role/roleList`; // 角色列表
export const UPDATE_ROLE_STATUS = `${API_BASE_URL}/admin/role/updateRoleStatus`; // 角色状态
export const ADD_ROLE = `${API_BASE_URL}/admin/role/addRole`; // 新增角色
export const EDIT_ROLE = `${API_BASE_URL}/admin/role/editRole`; // 修改角色
export const DELETE_ROLE = `${API_BASE_URL}/admin/role/deleteRole`; // 删除角色
export const UPDATE_ROLE_AUTH = `${API_BASE_URL}/admin/role/updateRoleAuth`; // 修改角色权限

export const TOL_MESSAGE_QUERY = `${API_BASE_URL}/tolMessage/query` //查询短信发送记录

export const SYS_APP_VERSION_QUERY = `${API_BASE_URL}/sysAppVersion/query` //查询app版本信息
export const SYS_APP_VERSION_UPDATE = `${API_BASE_URL}/sysAppVersion/update` //修改app版本信息

export const TOL_MSG_TEMPLATE_QUERY = `${API_BASE_URL}/tolMsgTemplate/query` //查询消息模版
export const TOL_MSG_TEMPLATE_ADD = `${API_BASE_URL}/tolMsgTemplate/add` //添加消息模版
export const TOL_MSG_TEMPLATE_UPDATE = `${API_BASE_URL}/tolMsgTemplate/update` //修改消息模版
export const TOL_MSG_TEMPLATE_DELETE= `${API_BASE_URL}/tolMsgTemplate/delete` //删除消息模版

export const GAME_CAMP_LIST = `${API_BASE_URL}/gameCamp/getGameCampList`; // 训练营列表
export const ADD_GAME_CAMP = `${API_BASE_URL}/gameCamp/add`; // 添加训练营
export const EDIT_GAME_CAMP = `${API_BASE_URL}/gameCamp/update`; // 编辑训练营
export const DELETE_GAME_CAMP = `${API_BASE_URL}/gameCamp/delete`; // 删除训练营

export const CAMP_DOC_LIST = `${API_BASE_URL}/campDoc/query`; // 训练营资料列表
export const ADD_CAMP_DOC = `${API_BASE_URL}/campDoc/add`; // 添加训练营资料
export const EDIT_CAMP_DOC = `${API_BASE_URL}/campDoc/update`; // 修改训练营资料
export const DELETE_CAMP_DOC = `${API_BASE_URL}/campDoc/delete`; // 删除训练营资料
// TODO:
export const CAMP_CONFIG_LIST = `${API_BASE_URL}/campConfig/query`; // 训练营配置列表
export const ADD_CAMP_CONFIG = `${API_BASE_URL}/campConfig/add`; // 添加训练营配置
export const EDIT_CAMP_CONFIG = `${API_BASE_URL}/campConfig/update`; // 编辑训练营配置
export const DELETE_CAMP_CONFIG = `${API_BASE_URL}/campConfig/delete`; // 删除训练营配置
export const CAMP_CONFIG_LIST_BY_ID = `${API_BASE_URL}/campConfig/getById`; // 训练营配置列表byId

export const GMAE_USER_KEY_LIST = `${API_BASE_URL}/gameUsrKey/query`; // 查询用户游戏解锁信息
export const GMAE_USER_KEY_LIST_BY_ID = `${API_BASE_URL}/gameUsrKey/getById`; // 根据ID用户游戏解锁信息
export const ADD_GMAE_USER_KEY = `${API_BASE_URL}/gameUsrKey/add`; // 添加用户游戏解锁信息
export const EDIT_GMAE_USER_KEY = `${API_BASE_URL}/gameUsrKey/update`; // 修改用户游戏解锁信息

export const GAME_USR_LIST = `${API_BASE_URL}/gameUsrList/query`; // 查询用户游戏记录
// MARK:
export const CAMP_CUST_LIST = `${API_BASE_URL}/campCust/query`; // 查询用户训练
export const AMP_CUST_LIST_BY_ID = `${API_BASE_URL}/campCust/getCampCustById`; // 根据ID查询用户训练信息
export const ADD_CAMP_CUST = `${API_BASE_URL}/campCust/add`; // 添加用户训练
export const DELETE_CAMP_CUST = `${API_BASE_URL}/campCust/delete`; // 删除用户训练
export const EDIT_CAMP_CUST = `${API_BASE_URL}/campCust/update`; // 修改用户训练

export const CAMP_CUST_MORE_LIST = `${API_BASE_URL}/campCustList/query`; // 查询用户训练明细

export const GAME_USR_LEVEL_HIS_LIST = `${API_BASE_URL}/gameUsrLevelHis/query`; // 查询用户闯关历史记录

export const GAME_USR_LEVEL_LIST = `${API_BASE_URL}/gameUsrLevel/query`; // 查询用户闯关记录

export const GAME_USER_LIST = `${API_BASE_URL}/gameUser/query`; // 查询游戏用户列表
export const GAME_USER_LIST_BY_ID = `${API_BASE_URL}/gameUser/getById`; // 查询游戏用户通过id

export const GAME_CODE_LIST = `${API_BASE_URL}/gameActiveCode/query`; // 游戏激活码列表
export const GAME_CREATE_CODE = `${API_BASE_URL}/gameActiveCode/gen`; //批量生产游戏激活码

export const PK_EXP_LIST = `${API_BASE_URL}/pk/expList`; // pk赛体验码列表
export const PK_CREATE_EXP_CODE = `${API_BASE_URL}/pk/createExpCode`; // 生成pk赛体验码
